import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'common/components';
import { Typography, Row, Col } from 'antd';

import MasterCase from './masterCase';
import RetailerUnit from './retailerUnit';

const { Text } = Typography;

const ProductPackaging = (props) => {
  const [form] = Form.useForm();
  const { productId, enumOptions } = props;

  return (
    <div style={{ marginTop: 24, paddingBottom: 24 }}>
      <Text>
        This information will be used to meet{' '}
        <Text strong>"Extended Producer Responsibility"</Text> regulations.
      </Text>

      <div style={{ marginTop: 16 }}>
        <Row gutter={[16, 16]} align="top">
          <Col xs={24} md={24}>
            <MasterCase productId={productId} form={form} enumOptions={enumOptions} />
          </Col>
          <Col xs={24} md={24}>
            <div style={{ paddingBottom: 24 }}>
              <RetailerUnit productId={productId} form={form} enumOptions={enumOptions} />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};

ProductPackaging.propTypes = {
  productItemModules: PropTypes.object,
  productId: PropTypes.any,
};

export default ProductPackaging;
